<script lang="ts" setup>
import { storeToRefs } from 'pinia'

import { useUserStore } from '@/stores/user'
import { useUserInboxStore } from '@/stores/userInbox'

const user = useUserStore()
const inbox = useUserInboxStore()
const { unreadCount, toastsMuted } = storeToRefs(inbox)
</script>

<template>
  <VBadge
    v-if="user.data?.access?.vector"
    :model-value="unreadCount > 0"
    :content="unreadCount > 99 ? '99+' : String(unreadCount)"
    color="info"
    location="top end"
  >
    <IconBtn @click="inbox.openDrawer()">
      <VIcon :icon="toastsMuted ? 'mdi-bell-off-outline' : 'mdi-bell-outline'" />
      <VTooltip v-if="toastsMuted" activator="parent" location="bottom">
        Popups & confetti muted
      </VTooltip>
    </IconBtn>
  </VBadge>
</template>
